import React from "react"
import ReactDOM from "react-dom"
import UniverseLandingPageHeroComponent from "./universe-landing-page-hero-component"

export default class UniverseLandingPageHero {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(
      <UniverseLandingPageHeroComponent
        heroImage={this.modelJson.heroImage}
        heroImageAltText={this.modelJson.heroImageAltText}
        opacity={this.modelJson.opacity}
        fontColor={this.modelJson.fontColor}
        infoHead={this.modelJson.infoHead}
        heading={this.modelJson.heading}
        subtext={this.modelJson.subtext}
        enableExpandHero={this.modelJson.enableExpandHero}
        mobileHeroImage={this.modelJson.mobileHeroImage}
        mobileHeroImageAltText={this.modelJson.mobileHeroImageAltText}
      />,
      self.elem,
    )
  }
}
